/**
 * Maximum character length for alt text.
 * Shared between frontend validation and backend sanitization.
 */
export const ALT_TEXT_MAX_LENGTH = 125;

export interface GenerateAltTextRequest {
  imageName: string;
}

export interface GenerateAltTextResponse {
  imageName: string;
  altText: string;
}

export interface SaveAltTextRequest {
  assetId: string;
  altText: string;
}

export interface MLFolder {
  description: string;
  value: string;
  children?: MLFolder[];
  locked: boolean;
}

export interface MLAsset {
  id: string;
  libraryId: string;
  thumbName: string;
  name: string;
  label: string;
  altText: string | null;
  mimeType: string;
  height: number;
  width: number;
  fileSize: number;
  status: number;
  created: string;
  createdBy: string;
}
